export const RapidRailKLType = Object.freeze({
    LRT: "LRT",
    MRT: "MRT",
    BRT: "BRT",
    MR: "MR"
});

export const serviceType = Object.freeze({
    LRT: "LRT",
    MRT: "MRT",
    MONORAIL: "Monorail",
    KTM: "KTM",
    ETS: "ETS",
    BRT: "BRT",
    ERL: "ERL",
    SKYPARK: "Skypark",
    INTERCITY: "Intercity",
    BUS: "BUS"
});

export const serviceTypeDetails = [
    { id: 1, type: 'LRT', fullName: 'Light Rail Transit', operator: 'RapidKL', color: '#008542' },
    { id: 2, type: 'MRT', fullName: 'Mass Rapid Transit', operator: 'RapidKL', color: '#d62027' },
    { id: 3, type: 'Monorail', fullName: 'KL Monorail', operator: 'RapidKL', color: '#81bc00' },
    // { id: 4, type: 'KTM', fullName: 'Keretapi Tanah Melayu', operator: 'KTMB', color: '#014F9A' },
    // { id: 5, type: 'ETS', fullName: 'Electric Train Service', operator: 'KTMB', color: '#F6C61C' },
    { id: 6, type: 'BRT', fullName: 'Bus Rapid Transit', operator: 'RapidKL', color: '#18563E' },
    { id: 7, type: 'ERL', fullName: 'Express Rail Link', operator: 'ERL', color: '#7B4099' },
    { id: 8, type: 'BUS', fullName: 'Rapid Rail BUS', operator: 'RapidBus', color: '#EF3125' },
];

export const subLineMap = {
    LRT: [
        {
            code: "KJ",
            name: 'Kelana Jaya Line',
            color: '#DE0E39'
        },
        {
            code: "AG",
            name: 'Ampang Line',
            color: '#EB7203',
        },
        {
            code: "SP",
            name: 'Sri Petaling Line',
            color: '#7C1E2A',
        },
    ],
    MRT: [
        {
            code: "KG",
            line: "MRT",
            name: 'Kajang Line',
            color: '#008640',
        },
        {
            code: "PY",
            line: "PYL",
            name: 'Putrajaya Line',
            color: '#fbcd20',
        },
    ],
};


